import Time from './time.vue';
export default Time;



// WEBPACK FOOTER //
// ./src/components/time/index.js